/* The Descent · Safari 97 · draft theme behaviour
   Terrain canvas, altimeter, camp ticks, buy widgets wired to /cart/add.js
   and Dawn's cart drawer. Runs only when the descent template is on the page. */
(function () {
  'use strict';
  /* lightweight event scaffold: no network calls; maps to GA4/Shopify analytics later */
  var s97Events = window.s97Events = window.s97Events || [];
  function track(ev, data) { s97Events.push({ t: Date.now(), ev: ev, data: data }); }
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    /* cart-aware CTAs: open Dawn's drawer where possible */
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-descent-open-cart]');
      if (!b) return;
      e.preventDefault();
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') d.open(b);
      else window.location.href = '/cart';
    });

    /* growers slideshow: manual navigation only, with a lightbox.
       Nothing on the descent auto-rotates except the mountain itself. */
    Array.prototype.forEach.call(document.querySelectorAll('[data-descent-slides]'), function (root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('.dsc-slide'));
      if (!slides.length) return;
      var dots = Array.prototype.slice.call(root.querySelectorAll('.dsc-slides-dots .dot'));
      var idx = 0;
      function show(n) {
        idx = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          s.classList.toggle('is-active', k === idx);
          s.setAttribute('aria-hidden', k === idx ? 'false' : 'true');
          var b = s.querySelector('.dsc-slide-btn');
          if (b) b.tabIndex = k === idx ? 0 : -1;
        });
        dots.forEach(function (d, k) {
          d.classList.toggle('is-active', k === idx);
          d.setAttribute('aria-current', k === idx ? 'true' : 'false');
        });
      }
      var prev = root.querySelector('.dsc-slides-nav.prev');
      var next = root.querySelector('.dsc-slides-nav.next');
      if (prev) prev.addEventListener('click', function () { show(idx - 1); });
      if (next) next.addEventListener('click', function () { show(idx + 1); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { show(+d.getAttribute('data-i')); });
      });

      var lb = null, lbImg, lbCap, lastFocus = null;
      function ensureLb() {
        if (lb) return;
        lb = document.createElement('div');
        lb.className = 'dsc-lb';
        lb.hidden = true;
        lb.setAttribute('role', 'dialog');
        lb.setAttribute('aria-modal', 'true');
        lb.setAttribute('aria-label', 'Origin photo');
        lb.innerHTML = '<button type="button" class="dsc-lb-close" aria-label="Close">×</button><figure><img alt=""><figcaption></figcaption></figure>';
        document.body.appendChild(lb);
        lbImg = lb.querySelector('img');
        lbCap = lb.querySelector('figcaption');
        lb.querySelector('.dsc-lb-close').addEventListener('click', closeLb);
        lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
        document.addEventListener('keydown', function (e) {
          if (!lb || lb.hidden) return;
          if (e.key === 'Escape') closeLb();
          else if (e.key === 'ArrowLeft') { show(idx - 1); fillLb(); }
          else if (e.key === 'ArrowRight') { show(idx + 1); fillLb(); }
        });
      }
      function fillLb() {
        var b = slides[idx].querySelector('.dsc-slide-btn');
        lbImg.src = b.getAttribute('data-full');
        lbImg.alt = b.getAttribute('data-caption') || 'Origin photo';
        lbCap.textContent = b.getAttribute('data-caption') || '';
      }
      function closeLb() {
        lb.hidden = true;
        document.body.style.overflow = '';
        if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
      }
      slides.forEach(function (s) {
        var b = s.querySelector('.dsc-slide-btn');
        if (b) b.addEventListener('click', function () {
          ensureLb();
          lastFocus = b;
          fillLb();
          lb.hidden = false;
          document.body.style.overflow = 'hidden';
          lb.querySelector('.dsc-lb-close').focus();
        });
      });
      show(0);
    });

    /* featured reviews: nothing moves on a clock. The card shows one review and
       advances to the next each time it scrolls back into view, so a reader
       working down the descent meets a different voice on each pass. Dots stay
       for manual navigation. */
    Array.prototype.forEach.call(document.querySelectorAll('[data-descent-reviews]'), function (root) {
      var revs = Array.prototype.slice.call(root.querySelectorAll('.rev'));
      if (revs.length < 2) return;
      var dots = Array.prototype.slice.call(root.querySelectorAll('.rev-dots .dot'));
      var idx = 0;
      function show(n) {
        idx = (n + revs.length) % revs.length;
        revs.forEach(function (r, k) {
          r.classList.toggle('is-active', k === idx);
          r.setAttribute('aria-hidden', k === idx ? 'false' : 'true');
        });
        dots.forEach(function (d, k) {
          d.classList.toggle('is-active', k === idx);
          d.setAttribute('aria-current', k === idx ? 'true' : 'false');
        });
      }
      dots.forEach(function (d) {
        d.addEventListener('click', function () { show(+d.getAttribute('data-i')); });
      });
      show(0);
      if (!('IntersectionObserver' in window)) return;
      /* first entry keeps review one; each re-entry after leaving moves on by one */
      var seenOnce = false, armed = false;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (armed) show(idx + 1);
            seenOnce = true;
            armed = false;
          } else if (seenOnce) {
            armed = true;
          }
        });
      }, { threshold: 0.6 }).observe(root);
    });

    var canvas = document.getElementById('descent-terra');
    if (!canvas) return;

    /* ---------- stages, palettes, stops ---------- */
    var PRAIRIE = { sky: '#FFF9F0', layers: ['#F2E8D5', '#E7D9BE', '#D9C8A7', '#C9B48E', '#2A1F1D'] };
    var stages = Array.prototype.slice.call(document.querySelectorAll('[data-descent-elev]'));
    var camps = stages.filter(function (s) { return s.hasAttribute('data-descent-palette'); });
    var palettes = camps.map(function (s) {
      try { return JSON.parse(s.getAttribute('data-descent-palette')); }
      catch (e) { return PRAIRIE; }
    });
    palettes.push(PRAIRIE);
    if (!palettes.length || !camps.length) return;

    var ctx = canvas.getContext('2d', { alpha: false });
    var W, H, dpr, prog = 0, stops = [], stageMeta = [];

    function makeNoise(seed) {
      var vals = [], s = seed, i;
      for (i = 0; i < 256; i++) { s = (s * 16807) % 2147483647; vals.push(s / 2147483647); }
      return function (x) {
        var fl = Math.floor(x), f = x - fl;
        var a = vals[fl & 255], b = vals[(fl + 1) & 255];
        var u = f * f * (3 - 2 * f);
        return a + (b - a) * u;
      };
    }
    var LAYERS = 5;
    var noises = [], FREQ = [];
    for (var L = 0; L < LAYERS; L++) { noises.push(makeNoise(97 + L * 41)); FREQ.push(0.0035 + L * 0.0016); }

    function hex2rgb(h) { return [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)]; }
    var PAL = palettes.map(function (p) { return { sky: hex2rgb(p.sky), layers: p.layers.map(hex2rgb) }; });
    function mix(a, b, t) { return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t]; }
    function css(rgb) { return 'rgb(' + (rgb[0] | 0) + ',' + (rgb[1] | 0) + ',' + (rgb[2] | 0) + ')'; }

    var altiBox = document.querySelector('.dsc-alti');
    var altiVal = document.getElementById('dscAltiVal');
    var lastTxt = '';

    function computeStops() {
      var doc = document.documentElement;
      var span = Math.max(1, doc.scrollHeight - doc.clientHeight);
      function centre(el) {
        var r = el.getBoundingClientRect();
        var top = r.top + window.scrollY;
        return Math.min(1, Math.max(0, (top + r.height / 2 - window.innerHeight / 2) / span));
      }
      stops = camps.map(centre);
      stops.push(1);
      stageMeta = stages.map(function (s) {
        var r = s.getBoundingClientRect();
        return { elev: +s.getAttribute('data-descent-elev'), ctr: r.top + window.scrollY + r.height / 2 };
      });
      placeTicks();
    }

    function placeTicks() {
      var col = document.querySelector('.dsc-alti .col');
      if (!col) return;
      if (!col.dataset.ticks) {
        camps.forEach(function (s) {
          var t = document.createElement('a');
          t.className = 'tick';
          t.href = '#' + s.id;
          t.setAttribute('aria-label', s.getAttribute('data-descent-label') || s.id);
          t.innerHTML = '<span class="tlabel">' + (s.getAttribute('data-descent-label') || '') + '</span>';
          col.appendChild(t);
        });
        col.dataset.ticks = '1';
      }
      Array.prototype.forEach.call(col.querySelectorAll('.tick'), function (t, i) {
        t.style.setProperty('--s', (stops[i] * 100) + '%');
      });
    }

    function palAt(p) {
      if (p <= stops[0]) return { a: PAL[0], b: PAL[0], t: 0 };
      for (var i = 0; i < stops.length - 1; i++) {
        if (p <= stops[i + 1]) {
          return { a: PAL[i], b: PAL[i + 1], t: (p - stops[i]) / Math.max(1e-6, stops[i + 1] - stops[i]) };
        }
      }
      var last = PAL[PAL.length - 1];
      return { a: last, b: last, t: 0 };
    }

    function drawSun(p) {
      var sink = Math.max(0, (p - 0.75) / 0.25);
      var x = W * (0.18 + 0.64 * p);
      var y = H * (0.17 - 0.05 * Math.sin(Math.PI * Math.min(1, p / 0.75)) + 0.30 * Math.pow(sink, 1.4));
      var r = 26 + 10 * sink;
      ctx.fillStyle = 'rgba(255,106,0,.9)';
      ctx.beginPath(); ctx.arc(x, y, r, 0, 6.283); ctx.fill();
      ctx.fillStyle = 'rgba(255,106,0,.14)';
      ctx.beginPath(); ctx.arc(x, y, r * 2.1, 0, 6.283); ctx.fill();
    }

    function draw() {
      var pal = palAt(prog);
      ctx.fillStyle = css(mix(pal.a.sky, pal.b.sky, pal.t));
      ctx.fillRect(0, 0, W, H);
      drawSun(prog);
      for (var L = 0; L < LAYERS; L++) {
        var n = noises[L];
        var offset = prog * 900 * (0.25 + L * 0.32);
        var baseY = H * (0.34 + L * 0.13) + Math.sin(prog * 3 + L) * 8;
        var amp = H * (0.05 + L * 0.035);
        ctx.fillStyle = css(mix(pal.a.layers[L], pal.b.layers[L], pal.t));
        ctx.beginPath();
        ctx.moveTo(0, H);
        for (var x = 0; x <= W + 8; x += 8) {
          var u = (x + offset) * FREQ[L];
          ctx.lineTo(x, baseY - (n(u) * 0.65 + n(u * 2.7) * 0.35) * amp);
        }
        ctx.lineTo(W, H);
        ctx.closePath();
        ctx.fill();
      }
      ctx.globalAlpha = 0.05;
      ctx.fillStyle = '#2A1F1D';
      for (var i = 0; i < 140; i++) {
        ctx.fillRect((i * 911 + ((prog * 4000) | 0)) % W, (i * 577) % H, 1.4, 1.4);
      }
      ctx.globalAlpha = 1;
    }

    function updateAlti() {
      if (!stageMeta.length || !altiVal) return;
      var mid = window.scrollY + window.innerHeight / 2;
      var i = 0, k;
      for (k = 0; k < stageMeta.length; k++) if (stageMeta[k].ctr <= mid) i = k;
      var a = stageMeta[i], b = stageMeta[Math.min(i + 1, stageMeta.length - 1)];
      var t = b.ctr === a.ctr ? 0 : Math.min(1, Math.max(0, (mid - a.ctr) / (b.ctr - a.ctr)));
      var elev = a.elev + (b.elev - a.elev) * t;
      var txt = Math.round(elev).toLocaleString('en-CA');
      if (txt !== lastTxt) { lastTxt = txt; altiVal.firstChild.nodeValue = txt; }
      if (altiBox) altiBox.style.setProperty('--p', (prog * 100) + '%');
    }

    function tick() {
      var doc = document.documentElement;
      prog = Math.min(1, doc.scrollTop / Math.max(1, doc.scrollHeight - doc.clientHeight));
      draw();
      updateAlti();
    }
    function resize() {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = window.innerWidth; H = window.innerHeight;
      canvas.width = W * dpr; canvas.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      computeStops();
      tick();
    }
    var queued = false, resizeQueued = false;
    window.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; tick(); });
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (resizeQueued) return;
      resizeQueued = true;
      requestAnimationFrame(function () { resizeQueued = false; resize(); });
    });
    /* recompute stops once everything (images, Dawn sections) has loaded */
    window.addEventListener('load', function () { computeStops(); tick(); });
    resize();

    /* ---------- buy widgets ---------- */
    function money(cents) { return '$' + (cents / 100).toFixed(2); }

    Array.prototype.forEach.call(document.querySelectorAll('[data-descent-card]'), function (card) {
      var cfgEl = card.querySelector('script[data-descent-config]');
      if (!cfgEl) return;
      var cfg;
      try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
      if (!cfg.variants || !cfg.variants.length) return;

      var state = {
        variant: cfg.variants[0],
        plan: (cfg.plans && cfg.plans.length) ? cfg.plans[0].id : null,
        subscribe: false
      };
      var sizeBtns = card.querySelectorAll('.opt.size');
      var rowBtns = card.querySelectorAll('.prow-head');
      var freqBtns = card.querySelectorAll('.opt.freq');
      var pOne = card.querySelector('[data-el="p-onetime"]');
      var pSub = card.querySelector('[data-el="p-sub"]');
      var addBtn = card.querySelector('.add-btn');

      function planPrice(variantId, planId) {
        var key = variantId + ':' + planId;
        return (cfg.planPrices && cfg.planPrices[key] != null) ? cfg.planPrices[key] : null;
      }
      function effective() {
        if (state.subscribe && state.plan) {
          var p = planPrice(state.variant.id, state.plan);
          if (p != null) return p;
        }
        return state.variant.price;
      }
      function render() {
        /* both purchase rows always show their price for the selected size */
        if (pOne) pOne.textContent = money(state.variant.price);
        if (pSub) {
          var p = state.plan != null ? planPrice(state.variant.id, state.plan) : null;
          pSub.innerHTML = (p != null)
            ? money(p) + '<span class="was">' + money(state.variant.price) + '</span>'
            : money(state.variant.price);
        }
        Array.prototype.forEach.call(rowBtns, function (b) {
          var on = (b.getAttribute('data-type') === 'subscribe') === state.subscribe;
          b.setAttribute('aria-checked', on ? 'true' : 'false');
          var row = b.closest('.prow');
          if (row) row.classList.toggle('sel', on);
        });
        if (addBtn) addBtn.textContent = 'Add to bag · ' + money(effective());
      }
      function select(group, btn) {
        Array.prototype.forEach.call(group, function (x) {
          x.classList.toggle('sel', x === btn);
          x.setAttribute('aria-pressed', x === btn ? 'true' : 'false');
        });
      }
      Array.prototype.forEach.call(sizeBtns, function (b) {
        b.addEventListener('click', function () {
          select(sizeBtns, b);
          var id = +b.getAttribute('data-variant');
          state.variant = cfg.variants.filter(function (v) { return v.id === id; })[0] || cfg.variants[0];
          render();
          track('size_select', { id: card.getAttribute('data-descent-card') || '', size: state.variant.title });
        });
      });
      Array.prototype.forEach.call(rowBtns, function (b) {
        b.addEventListener('click', function () {
          state.subscribe = b.getAttribute('data-type') === 'subscribe';
          render();
          track('type_select', { type: state.subscribe ? 'subscribe' : 'one-time' });
        });
      });
      Array.prototype.forEach.call(freqBtns, function (b) {
        b.addEventListener('click', function () {
          select(freqBtns, b);
          state.plan = +b.getAttribute('data-plan');
          state.subscribe = true;
          render();
          track('freq_select', state.plan);
        });
      });
      if (addBtn) addBtn.addEventListener('click', function () {
        addBtn.disabled = true;
        var item = { id: state.variant.id, quantity: 1 };
        if (state.subscribe && state.plan) item.selling_plan = state.plan;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [item], sections: 'cart-drawer,cart-icon-bubble' })
        }).then(function (r) { return r.json(); }).then(function (data) {
          addBtn.disabled = false;
          var drawer = document.querySelector('cart-drawer');
          if (drawer && data.sections && data.sections['cart-drawer']) {
            var dd = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
            var next = dd.querySelector('cart-drawer');
            if (next) drawer.innerHTML = next.innerHTML;
            drawer.classList.remove('is-empty');
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble && data.sections['cart-icon-bubble']) {
              var bb = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
              var nb = bb.querySelector('.shopify-section');
              if (nb) bubble.innerHTML = nb.innerHTML;
            }
            if (typeof drawer.open === 'function') drawer.open(addBtn);
          } else {
            window.location.href = '/cart';
          }
        }).catch(function () {
          addBtn.disabled = false;
          window.location.href = '/cart';
        });
      });
      render();
    });
  });
})();
